import * as React from "react";
import PropTypes from 'prop-types';

const SvgCartLarge = props => {
  if (props.id !== "_svgcartlarge") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M32.077 23.989l1.932-10.956a1 1 0 011.158-.811l.142.025a1 1 0 01.81 1.158l-2.098 11.903v.006a1 1 0 01-1 1H9.951a1 1 0 01-1-1v-.005L6.453 11.144H3a1 1 0 01-1-1V10a1 1 0 011-1h4.432a1 1 0 011 1v.017l2.463 13.972h21.182zM12.58 33a2.512 2.512 0 110-5.025 2.512 2.512 0 010 5.025zm17.166 0a2.512 2.512 0 110-5.025 2.512 2.512 0 010 5.025z" fillRule="evenodd" /></svg>;
};

SvgCartLarge.displayName = "_svgcartlarge";
SvgCartLarge.propTypes = {
  id: PropTypes.string
};
SvgCartLarge.defaultProps = {
  id: ''
};
export default SvgCartLarge;